import View from './view.js'
import { useDataValue } from 'Simple/Data.js'

export default function Logic(props) {
  let questionId = useDataValue({
    context: 'question',
    viewPath: props.viewPath,
    path: 'id',
  })

  let usePatientPhone = useDataValue({
    context: 'phoneDetails',
    viewPath: props.viewPath,
    path: 'responsiblePersonPhoneDetails.usePatientPhone',
  })

  return (
    <View
      {...props}
      disabled={
        questionId === 'responsiblePersonPhoneDetails' && usePatientPhone
      }
    />
  )
}
